/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateInvestmentHolding} from '../api'

export const useMutationUpdateInvestmentHolding = createReactQueryMutationHook('updateInvestmentHolding', updateInvestmentHolding)
